export default __webpack_public_path__ + "static/media/goldGiftIcon.84d06156.svg";